import api from './api'

export interface SeatPreview {
  stripeConfigured: true
  currentSeats: number
  newSeats: number
  pricePerSeat: number
  currency: string
  billingInterval: string
}

export interface SeatPreviewUnconfigured {
  stripeConfigured: false
}

export type SeatPreviewResult = SeatPreview | SeatPreviewUnconfigured

export interface BillingStatus {
  stripeConfigured: true
  plan: 'trial' | 'active' | 'past_due' | 'canceled'
  trialEndsAt: string | null
  seatCount: number
  currentPeriodEnd?: string | null
  cancelAtPeriodEnd?: boolean
  pricePerSeat?: number | null
  currency?: string | null
}

export interface BillingStatusUnconfigured {
  stripeConfigured: false
}

export type BillingStatusResult = BillingStatus | BillingStatusUnconfigured

export const billingService = {
  async getSeatPreview(adding = 1): Promise<SeatPreviewResult> {
    const { data } = await api.get('/billing/seat-preview', { params: { adding } })
    return data as SeatPreviewResult
  },

  async getStatus(): Promise<BillingStatusResult> {
    const { data } = await api.get('/billing/status')
    return data as BillingStatusResult
  },

  async createPortalSession(): Promise<string> {
    const { data } = await api.post('/billing/portal-session')
    return (data as { url: string }).url
  },
}
